import {
  addDays,
  formatCivilDate,
  isCivilDateBefore,
  listPeriods,
  parseCivilDate,
  type RecurrenceRule,
} from '@klopotun/domain';
import { PAST_PAYMENT_STATE, type PastPaymentDraft } from '../model/payment-form-values.js';

/**
 * The due dates already behind today that the schedule produces, oldest first. The same domain
 * function the server materialises with, so every date here is one the server will accept.
 */
export const pastDueDatesOf = (rule: RecurrenceRule, today: string): string[] => {
  const yesterday = addDays(parseCivilDate(today), -1);

  if (isCivilDateBefore(yesterday, rule.startDate)) {
    return [];
  }

  return listPeriods(rule, { from: rule.startDate, to: yesterday }).map((period) =>
    formatCivilDate(period.dueDate),
  );
};

type HistoryMerge = {
  existing: PastPaymentDraft[];
  dueDates: string[];
};

const paidAtSubscriptionAmount = (dueDate: string): PastPaymentDraft => ({
  dueDate,
  state: PAST_PAYMENT_STATE.PAID,
  amount: null,
  isEdited: false,
});

export const mergeHistory = ({ existing, dueDates }: HistoryMerge): PastPaymentDraft[] => {
  const editedByDueDate = new Map(
    existing.filter((draft) => draft.isEdited).map((draft) => [draft.dueDate, draft] as const),
  );

  return dueDates.map(
    (dueDate) => editedByDueDate.get(dueDate) ?? paidAtSubscriptionAmount(dueDate),
  );
};
